/* eslint-disable no-unused-vars */
import { Box, Grid, styled, Typography, Button, Paper, TextField, MenuItem } from "@mui/material"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/cs';
import Typed from "typed.js";
import { useEffect, useRef } from "react";
import Typewriter from 'typewriter-effect';
const HeaderContainer = styled(Box)(({ theme }) => ({
    position: 'relative',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 0,
        transition: "opacity 0.2s ease-in",
    },
    backgroundImage: "url(/header.jpeg)",
    backgroundAttachment: "fixed, scroll",
    backgroundSize: "contain",
    height: "12rem",
    WebkitBackgroundSize: "cover",
    backgroundPosition: "center",
    WebkitBackgroundPosition: "cover",
    [theme.breakpoints.down("md")]: {
        padding: "1rem",
        backgroundAttachment: "scroll"
    },
    "&:hover": {
        "&::before": {
            opacity: 0.8
        },
    }
}));

function Headers({ children }) {
    return (
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <HeaderContainer>
                    <Grid container sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        p: 5,
                        zIndex: 9999
                    }}>
                        <Grid item xs={12} md={12} sx={{
                            zIndex: 9999,
                            textAlign: "center"
                        }}>
                            <Typography
                                variant="h2"
                                component="h1"
                                color={"white"}
                            >
                                {children}
                            </Typography>
                            <Typography variant="subtitle2" sx={{
                                textTransform: "uppercase",
                                fontWeight: "bold",
                                color: "white"
                            }}>RSrent </Typography>
                        </Grid>
                    </Grid>
                </HeaderContainer>
            </Grid>
        </Grid>
    )
}

export default Headers